import React, {useEffect} from "react";
import '../theme/sidenav.css';
import {useLocation} from "react-router-dom";
import {ApiService} from "../api/ApiService";
import {create} from "zustand";

interface MostUsedPagesState {
    mostUsedPages: {page: string, count: number}[];
    setMostUsedPages: (pages: any[]) => void;
}

export const useMostUsedPagesStore = create<MostUsedPagesState>((set) => ({
    mostUsedPages: [],
    setMostUsedPages: (pages: {page: string, count: number}[]) => set({ mostUsedPages: pages }),
}));

const AppPageTracker: React.FC = () => {
    const excludedPages = ['/trip', '/load', '/money', '/docs', '/settings', '/notifications', '/inbox', '/'];
    const homePage = '/home';
    const mostUsedPagesStore = useMostUsedPagesStore();
    const setMostUsedPages = mostUsedPagesStore.setMostUsedPages;

    const routeInfo = useLocation();
    useEffect(() => {
        if (!routeInfo.pathname || excludedPages.includes(routeInfo.pathname.toLowerCase())) {
            return;
        }
        const page = routeInfo.pathname;
        ApiService.getMostUsedPages('home', {}).then(it => {
            console.log(it);
            if (page.toLowerCase() === homePage) {
                setMostUsedPages(it);
                return;
            }
            const pages = Array.isArray(it) ? [...it] : [];
            const existingPage = pages.find(it => it.page === page);
            if (existingPage) {
                existingPage.count++;
            } else {
                pages.push({page: page, count: 1});
            }
            setMostUsedPages(pages);

            ApiService.saveMostUsedPages(page, {pagesArray: JSON.stringify(pages)})
        });
    }, [routeInfo]);

    return <></>
}
export default AppPageTracker;
